import React from 'react';
import Method from '../../../_shared/assets/img/method.png';
import { ReactComponent as CloseIcon } from '../../assets/icons/close.svg';
import { ReactComponent as InfoIcon } from '../../../_shared/assets/icons/info-icon.svg';
import { ReactComponent as ArrowIcon } from '../../assets/icons/arrow-left.svg';
import { Modal } from '../Modal/Modal';
import { Typography } from '../Typography/Typography';
import { Button } from '../Button/Button';
import styles from './KpiCalculationMethodModal.module.scss';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  notification?: string;
}

export function KpiCalculationMethodModal({
  isOpen,
  onClose,
  notification
}: Props) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <button className={styles.back} onClick={onClose}>
        <ArrowIcon />
        Назад
      </button>
      <button className={styles.closeIcon} onClick={onClose}>
        <CloseIcon />
      </button>
      <div className={styles.kpiModal}>
        <div className={styles.head}>
          <Typography variant="h2" className={styles.title}>
            Методика расчета
          </Typography>
          {notification && (
            <div className={styles.notification}>
              <span className={styles.notificationIcon}>
                <InfoIcon />
              </span>
              <Typography variant="text">{notification}</Typography>
            </div>
          )}
        </div>
        <div className={styles.method}>
          <img src={Method} alt="method" />
        </div>
        <div className={styles.actions}>
          <Button
            variant="secondary"
            size="small"
            className={styles.button}
            onClick={onClose}
          >
            Закрыть
          </Button>
          <Button
            variant="primary"
            size="small"
            className={styles.button}
            onClick={onClose}
          >
            Скачать документ
          </Button>
        </div>
      </div>
    </Modal>
  );
}
